import { FormatNumber } from '@components/formatNumber';
import type { NumbersGroupPropsType } from './types';

const NumbersGroup = (props: NumbersGroupPropsType) => {
  const groupClassName =
    props.className === 'performanceWrapper'
      ? 'performanceWrapper ml-auto mr-[15%] mb-5 border-r-[3px] border-[#668272] text-right text-[#668272]'
      : 'benchmarkWrapper ml-auto mr-[15%] mt-[60px] mb-5 border-r-[3px] border-black text-right text-black';

  return (
    <div
      className={`${groupClassName} cursor-default transition-opacity`}
      onMouseEnter={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onMouseEnter(props.id);
      }}
      onMouseLeave={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onMouseLeave(props.id);
      }}
    >
      <div className="PerformanceOverviewNumbersGroup-inline">
        <div className="mr-[45px] ml-auto font-heading text-[32px] leading-8 italic font-normal">
          {typeof props.value === 'number' ? (
            <FormatNumber useLocale={props.language} suffix="%">
              {props.value}
            </FormatNumber>
          ) : (
            '--'
          )}
        </div>
        <div className="mr-[45px] ml-auto mb-5 text-xs leading-[14px] text-black">{props.labelText}</div>
      </div>

      <div className="PerformanceOverviewNumbersGroup-inline">
        <div className='mr-[45px] ml-auto font-["Times_New_Roman"] text-[32px] leading-8 italic font-normal'>
          {typeof props.paValue === 'number' ? (
            <FormatNumber useLocale={props.language} suffix="%">
              {props.paValue}
            </FormatNumber>
          ) : (
            '--'
          )}
        </div>
        <div className="mr-[45px] ml-auto mb-5 text-xs leading-[14px] text-black">{props.labelPaText}</div>
      </div>
    </div>
  );
};

export { NumbersGroup };
